/*
time:2021-9-2
author:ashinz
description:Drop User Info 界面
*/

import React from 'react';
import {
  Card,
  Copy,
  Form,
  ExternalLink,
} from '@tencent/tea-component';
import { bindActionCreators } from 'redux';
import DropActionCreator from '@/api/DropActions';
import { Textarea } from 'tdesign-react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import '@tencent/tea-component/dist/tea.css';
import { getOAName, getUserUid } from '@/utils/Storage';
import '../Drop.css';
import PropTypes from 'prop-types';
import AccessAgent from '../../components/accessAgent';
import axios from 'axios';
import { HOST_URL } from '@/config';
import { goodStatus } from '@/utils/ErrorConfirm';

// 动态生成 MCP_JSON 的函数 - 完整版本（用于复制）
const getMcpJson = () => {
  const dropToken = localStorage.getItem('key') || null;

  return `{
  "mcpServers": {
    "drop-mcp-server": {
      "url": "http://drop.qcloud.com:8888/sse?token=${dropToken || 'null'}&user=${getOAName() || 'null'}",
      "timeout": 600
    }
  }
}`;
};
// 动态生成 MCP_JSON 的函数 - 脱敏版本（用于显示）
const getMcpJsonMasked = () => {
  const dropToken = localStorage.getItem('key') || null;

  // 对 token 进行脱敏处理：显示前6位，其余用*替代
  const maskedToken = dropToken ? `${dropToken.substring(0, 0)}${'*'.repeat(Math.max(0, dropToken.length - 6))}` : 'null';

  return `{
  "mcpServers": {
    "drop-mcp-server": {
      "url": "http://drop.qcloud.com:8888/sse?token=${maskedToken}&user=${getOAName() || 'null'}",
      "timeout": 600
    }
  }
}`;
};

class DropUserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: getOAName(), // 用户名 通过tps获取
      uid: getUserUid(), // 用户uid
      key: localStorage.getItem('key') || null, // 用户密钥
    };
  }

  componentDidMount() {
    if (this.state.key === null) {
      axios({
        method: 'get',
        url: `${HOST_URL}/api/v1/users`,
        params: {
          user: getOAName(),
        } })
        .then((response) => {
          if (goodStatus(response)) {
            localStorage.setItem('key', response?.data?.key);
            this.setState({ key: response?.data?.key });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  render() {
    // 渲染uid的模块
    const content = <div className="drop-user-info-show-module-style">
            <div style={{ margin: '10px auto', padding: '20px' }}>
                <Card style={{ width: '80%' }}>
                    <Card.Body
                        title="用户信息"
                    >
                        <Form readonly>
                            <Form.Item label="用户名">
                                <Form.Text>{this.state.user}</Form.Text>
                            </Form.Item>
                            <Form.Item label="uid">
                                {!this.state.uid
                                  ?                                   <Form.Text>加载中</Form.Text>
                                  : <Form.Text>{this.state.uid} <Copy text={this.state.uid}></Copy></Form.Text>}
                            </Form.Item>
                            <Form.Item label="用户密钥">
                                {!this.state.key
                                  ? <Form.Text>加载中</Form.Text>
                                  : <Form.Text>****** <Copy text={this.state.key}></Copy></Form.Text>}
                            </Form.Item>
                        </Form>
                    </Card.Body>
                </Card>
                <Card style={{ width: '80%' }}>
                   <AccessAgent></AccessAgent>
                </Card>
                <Card style={{ width: '80%' }}>
                   <Card.Body title="Drop-MCP接入" operation={<ExternalLink href='https://iwiki.woa.com/p/4014886522'>使用指引</ExternalLink>}>
                        <Form.Text>在完成快速开始的机器接入后，支持通过MCP来发起性能分析任务并获取结果，助力优化代码。</Form.Text>
                        <Form.Text>⚠️ 安全提示：下方配置已脱敏显示，请点击复制按钮获取完整配置
                            <Copy text={getMcpJson()}></Copy>
                        </Form.Text>
                        <Textarea
                              style={{
                                background: '#f5f5f5',
                                color: 'black',
                                userSelect: 'none',
                                WebkitUserSelect: 'none',
                                MozUserSelect: 'none',
                                msUserSelect: 'none',
                                cursor: 'not-allowed',
                                border: '1px dashed #ccc'
                              }}
                              autosize={{ minRows: 6, maxRows: 8 }}
                              value={getMcpJsonMasked()}
                              readonly={true}
                              disabled
                          />
                        <Form.Text>在 IDE 侧的 mcp.json 配置上述命令，保存即可实现接入。</Form.Text>
                    </Card.Body>
                </Card>
            </div>
        </div>;
    return content;
  }
}

DropUserInfo.propTypes = {
  DropAction: PropTypes.any.isRequired,
  DropReducer: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => {
  const { DropReducer } = state;
  return {
    DropReducer,
  };
};// Reducer

const mapDispatchToProps = (dispatch) => {
  const DropAction = bindActionCreators(DropActionCreator, dispatch);

  return {
    DropAction,
  };
};// Action

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DropUserInfo));

